module.exports = __webpack_public_path__ + "img/FLOWER HAT PURPLE.641dbbf.svg";